import styled from 'styled-components';
import { ButtonBase, TextField } from '@mui/material';
import { timeFormat } from 'd3-time-format';
import { FORMAT_DATE, FORMAT_TIME } from 'src/constants';
import DateTimePicker from '@mui/lab/DateTimePicker';
import DatePicker from '@mui/lab/DatePicker';
import { useState } from 'react';
import React from 'react';
import { salesOrderStartTimeOnDay } from 'src/server/item-drag-drop';

export const DatePickerDisplay: React.FC<{
  value: Date;
  minDate?: Date;
  maxDate?: Date;
  setValue?: (v: Date) => void;
  dateOnly?: boolean;
}> = ({ minDate, maxDate, value, setValue, dateOnly }) => {
  const [openDatePicker, setOpenDatePicker] = useState(false);

  const renderInput = (params: any) =>
    setValue ? (
      <div style={{ position: 'relative' }}>
        <TextField
          {...params}
          style={{
            position: 'absolute',
            left: 20,
            bottom: -10,
            visibility: 'hidden',
          }}
        />
        <DateDisplay
          open={setOpenDatePicker}
          value={value}
          dateOnly={dateOnly}
        />
      </div>
    ) : (
      <StaticDateDisplay value={value} dateOnly={dateOnly} />
    );

  if (dateOnly) {
    return (
      <DatePicker
        value={value}
        onOpen={() => setOpenDatePicker(true)}
        onClose={() => setOpenDatePicker(false)}
        open={openDatePicker}
        onChange={(v: Date | null) => {
          if (v) setValue?.(salesOrderStartTimeOnDay(v));
        }}
        minDate={minDate}
        maxDate={maxDate}
        disabled={setValue === undefined}
        label="Date"
        disableCloseOnSelect={false}
        renderInput={renderInput}
      />
    );
  }

  return (
    <DateTimePicker
      value={value}
      onOpen={() => setOpenDatePicker(true)}
      onClose={() => setOpenDatePicker(false)}
      open={openDatePicker}
      onChange={(v: any) => {
        setValue?.(v!);
      }}
      minDate={minDate}
      maxDate={maxDate}
      disabled={setValue === undefined}
      ampm
      minutesStep={15}
      label="Start"
      disableCloseOnSelect={false}
      renderInput={renderInput}
    />
  );
};

const timeFormatter = timeFormat(FORMAT_TIME);
const dayFormatter = timeFormat(FORMAT_DATE);

const DateDisplay: React.FC<{
  open: (x: boolean) => void;
  value: Date;
  dateOnly?: boolean;
}> = ({ open, value, dateOnly }) => {
  return (
    <DateDisplayStyle onClick={() => open(true)}>
      <div>
        {!dateOnly && <div className="time">{timeFormatter(value)}</div>}
        <div className={dateOnly ? 'time' : 'day'}>{dayFormatter(value)}</div>
      </div>
    </DateDisplayStyle>
  );
};

export const StaticDateDisplay: React.FC<{
  value: Date;
  dateOnly?: boolean;
}> = ({ value, dateOnly }) => (
  <DateDisplayStyle disabled>
    <div>
      {!dateOnly && <div className="time">{timeFormatter(value)}</div>}
      <div className={dateOnly ? 'time' : 'day'}>{dayFormatter(value)}</div>
    </div>
  </DateDisplayStyle>
);

const DateDisplayStyle = styled(ButtonBase)`
  .time {
    font-size: 16px;
    font-weight: bold;
  }

  .day {
    font-size: 12px;
    margin-left: -5px;
  }
`;
